import { html, ifDefined } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { config } from '../config.js';
import { customerDataManager, infrastructure, moduleLoader } from '../infrastructure.js';

/**
 * @param {UrlSearchParams} query - object representing query parameters
 * @param {string} anchor - string representing anchor fragment
 * @returns {TemplateResult}
 */
export default function renderDashboardPageTemplate({ query, anchor }) {
  moduleLoader.loadModule(config.villanelleWidgetUrl);

  return html`
    <osk-dashboard-page
      .infrastructure=${infrastructure}
      .query=${query}
      anchor=${ifDefined(anchor)}
      working-sn=${customerDataManager.workingSn}
    ></osk-dashboard-page>
  `;
}
